import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'page-add-modal',
  templateUrl: './page-add-modal.component.html',
  styleUrls: ['./page-add-modal.component.scss']
})
export class PageAddModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
